import { Root } from './NoSections.module.css';

const NoSections = () => (
  <div className={Root}>No content yet. Start building!</div>
);

export default NoSections;
